import { render } from "./GymImportTab.vue?vue&type=template&id=239dd268&scoped=true"
import script from "./GymImportTab.vue?vue&type=script&lang=js"
export * from "./GymImportTab.vue?vue&type=script&lang=js"

import "./GymImportTab.vue?vue&type=style&index=0&id=239dd268&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-239dd268"]])

export default __exports__